<div class="loading-container" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Carregando dados...</p>
</div>

<div class="main-container" *ngIf="!isLoading && !toggle">
    <div class="close-background" (click)="onToggleClick($event)"></div>
    <div class="table-container" (click)="$event.stopPropagation()">
        <div class="table-header">
            <button class="add-button" (click)="toggleForm()">+</button>
            <h2 class="title">VIAGENS PROGRAMADAS</h2>

            <div class="dropdown">CLASSIFICAÇÃO
                <div class="select" (click)="toggleDropdown()">
                    <span class="selected">{{selectedOption}}</span>
                    <div class="caret" [class.caret-rotate]="dropdownOpen"></div>
                </div>

                <ul class="menu" [class.menu-open]="dropdownOpen">
                    <li *ngFor="let option of options" (click)="selectOption(option)"
                        [class.active]="option === selectedOption">
                        {{option}}
                    </li>
                </ul>
            </div>
        </div>

        <div class="division"></div>
        <div class="scrollable-table">

            <table class="table">
                <thead>
                    <tr>
                        <th>VIAGEM</th>
                        <th>CLASSIFICAÇÃO</th>
                        <th>EMPRESA</th>
                        <th>TIPO</th>
                        <th>CHEGADA</th>
                        <th>SAÍDA</th>
                        <th>AÇÃO</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let trip of data$ | async">
                        <td>{{trip.trip}}</td>
                        <td>{{trip.classification}}</td>
                        <td>{{trip.company}}</td>
                        <td>{{trip.category}}</td>
                        <td>{{trip.arrivalTime}}</td>
                        <td>{{trip.departureTime}}</td>
                        <td>
                            <div class="actions">
                                <button class="edit" (click)="openEditForm(trip)"><fa-icon [icon]="faPen"></fa-icon></button>
                                <button class="delete" (click)="deleteTripById(trip.id, trip.trip)"><fa-icon [icon]="faTrash"></fa-icon></button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<app-planning-table-form *ngIf="showForm" class="overlay" (closeForm)="toggleForm()" (dataUpdated)="onDataUpdated()"
    [receivedTrip]="tripToEdit"></app-planning-table-form>